<app-bread-crumb [Locations]="[{target : 'home', label : 'Home'}]" current="Report Pollution">
</app-bread-crumb>
<div class="nsw-container page-container">
    <div class="nsw-layout">
        <main class="nsw-layout__main">
            <!-- START: Main content -->
            <div class="nsw-docs__box nsw-docs__box--large">
                <div class="content">
                    <h2>Report pollution</h2>
                    <h3 style=" margin-top: 2rem;">Reporting pollution incidents</h3>
                    <p>
                        Reports from the community can play an important role in investigating incidents. To report
                        pollution at a swim site please contact the EPA Environment Line at any time.
                    </p>
                    <br/><br/>

                    <a type="button" [href]="REPORT_POLLUTION_TO_EPA_URL" target="_blank"
				        class="nsw-button nsw-button--dark about-program-btn">Report to the EPA
                    </a>                    
                </div>
                
            </div>
            <!-- END: Main content -->
        </main>

        <div class="nsw-layout__sidebar" style="height: fit-content;margin-bottom : 0">
            <div class="nsw-card" >
                <div class="nsw-card__content sidebar-card-content">
                    <div class="nsw-card__title">
                        <h4 class="nsw-fh4">Call 000 to report major pollution incidents</h4>                     
                    </div>
                    <div class="nsw-card__copy">
                        <p> 
                            If you observe a major pollution incident that presents an <b>immediate threat to human health or property</b>,
                            such as toxic fumes or a large chemical spill, <b>call 000</b> to report it to emergency services.
                        </p>
                    </div>                   
                </div>
            </div>
        </div>

       
    </div>
</div>
<div class="nsw-container">
            <div class="nsw-layout">
        <main class="nsw-layout__main">
            <div class="nsw-grid nsw-grid--spaced">
                <div class="nsw-col">
                    <span class="nsw-section-title">
                        <h2>You may also be interested in</h2>
                    </span>
                    <div class="nsw-grid">
                        <div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
                            <app-content-card title="Is it safe to swim?"
                                description="Learn a few easy ways you can check to help you decide where and when to swim."
                                [link]="['../whatIsBeachwatch/safeToSwim']" [isExternalLink]="false">
                            </app-content-card>
                        </div>
                        <div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
                            <app-content-card title="Have you spotted an algal bloom?"
                                description="Report suspected algal blooms to Water NSW."
                                link="https://www.waternsw.com.au/water-services/water-quality/algae"
                                [isExternalLink]="true">
                            </app-content-card>
                        </div>
                        <div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
                            <app-content-card title="Explore our data"
                                description="View or download data collected by Beachwatch and our partners."
                                [link]="['../waterMonitoring/waterQualityData']" [isExternalLink]="false">
                            </app-content-card>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</div>
